import React from 'react'
import { Link } from "react-router-dom";

const SolarElectricalInstallation = () => {
  return (
    <>

      <div className="page-header dark-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="A Complete Guide to Solar Energy ..." style={{ perspective: 400 }}>
                  <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                    <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                      Solar & Electrical Installation
                    </div>
                  </div>
                </h1>
                <div className="post-single-meta wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <ol className="breadcrumb">
                    <a to='/'> <li><i className="fa-regular fa-user" /> Home</li></a>
                    <li><i className="fa-regular fa-clock" /> Solar & Electrical Installation</li>
                  </ol>
                </div>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>

      <div className="page-service-single">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              {/* Page Single Sidebar Start */}
              <div className="page-single-sidebar">
                {/* Page Category List Start */}
                <div className="page-category-list wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                  <h2 className="page-category-list-title">Explore Our Services</h2>
                  <ul>
                    <li><Link to="/solar-electrical-installation">Solar & Electrical Installation</Link></li>
                    <li><Link to="/on-grid-off-grid-solar">On-Grid & Off-Grid Solar</Link></li>
                    <li><Link to="/solar-water-heater-solution">Solar Water Heater Solution</Link></li>
                    <li><Link to="/hybrid-solar-power-plant">Hybrid Solar Power Plant</Link></li>
                    <li><Link to="/EV-charging-solution">EV Charging Solution</Link></li>
                    <li><Link to="/solar-water-pump-solution">Solar Water Pump Solution</Link></li>
                  </ul>
                </div>
                {/* Page Category List End */}
                {/* Sidebar CTA Box Start */}
                <div className="sidebar-cta-box wow fadeInUp" data-wow-delay="0.25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                  <div className="sidebar-cta-header">
                    <div className="icon-box">
                      <img src="./assets/images/icon-headphone-white.svg" alt />
                    </div>
                    <div className="sidebar-cta-image">
                      <figure>
                        <img src="./assets/images/sidebar-cta-image.png" alt />
                      </figure>
                    </div>
                  </div>
                  <div className="sidebar-cta-body">
                    <h2>Contact Us For a Quote</h2>
                    <ul>
                      <li>Call Us: <a href="tel:+91 9516839231">+91 9516839231</a></li>
                    </ul>
                  </div>
                </div>
                {/* Sidebar CTA Box End */}
              </div>
              {/* Page Single Sidebar End */}
            </div>
            <div className="col-lg-8">
              {/* Service Single Content Start */}
              <div className="service-single-content">
                {/* Page Single Image Start */}
                <div className="page-single-image">
                  <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                    <img src="./assets/solar/Solar & Electrical Installation.webp" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                  </figure>
                </div>
                {/* Page Single Image End */}
                {/* Service Entry Start */}
                <div className="service-entry">
                  <div className="service-offer-box">
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="What we offer" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Professional Solar & Electrical Installation Services
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>At Solar World Enterprises, we provide professional Solar & Electrical Installation services for residential, commercial, industrial, agricultural, and institutional requirements. Our team focuses on safe, reliable, and efficient installation of solar energy systems and associated electrical components.</p>
                    {/* Service Offer Box List Start */}
                    {/* <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li>Improve energy independence &amp; reliability</li>
                        <li>Backup power during grid outages</li>
                        <li>Smart energy management &amp; monitoring</li>
                        <li>Lower electricity bills using store energy</li>
                      </ul>
                    </div> */}
                  </div>
                  {/* Service Offer Box End */}
                  {/* Service Key Benefits Start */}
                  <div className="service-key-benefits">
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Our Solar Installation Services
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>We handle the complete solar installation process, including site assessment, system design, mounting structure installation, solar panel installation, inverter installation, DC/AC wiring, electrical connections, testing, and commissioning.</p>
                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                          Our Electrical Installation Services
                        </div>
                      </div>
                    </h2>
                    <p className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Our electrical installation services include the installation and connection of electrical equipment and components associated with solar power systems. We focus on proper wiring, protection systems, distribution connections, earthing, and other essential electrical requirements according to the project.</p>
                    {/* Service Key Benefits Body Start */}
                    <div className="service-key-benefits-body">
                      {/* Service Benefits Image Start */}
                      <div className="service-benefit-image">
                        <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                          <img src="./assets/images/service-benefit-image.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} />
                        </figure>
                      </div>
                      {/* Service Benefits Image End */}
                      {/* Service Benefits Item List Start */}
                      <div className="service-benefit-item-list">
                        {/* Service Benefits Item Start */}
                        <div className="service-benefit-item wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                          <div className="icon-box">
                            <img src="./assets/images/icon-service-benefit-1.svg" alt />
                          </div>
                          <div className="service-benefit-item-content">
                            <h3>Complete Installation Process</h3>
                            <p><b>Site Assessment → System Design → Equipment Installation → Electrical Wiring → Safety Checks → Testing → Commissioning</b></p>
                            <h3>Reliable Power Starts with Proper Installation</h3>
                            <p>A well-designed solar system requires proper installation to achieve reliable and efficient operation. At Solar World Enterprises, we combine solar expertise with electrical installation capabilities to provide customers with a convenient, end-to-end solution.</p>
                          </div>

                        </div>
                      </div>
                      {/* Service Benefits Item List End */}
                    </div>

                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Our key benefits" style={{ perspective: 400 }}>
                      <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block', marginTop: "20px" }}>
                          Why Choose Our Installation Services?
                        </div>
                      </div>
                    </h2>
                    <div className="service-offer-box-list wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                      <ul>
                        <li><b>Professional Installation:</b> Careful and systematic installation by trained personnel.</li>
                        <li><b>Customized Solutions:</b> Installation planned according to your property's energy requirements and available space.</li>
                        <li><b>Safety Focused:</b> Attention to electrical connections, protection, earthing, and overall system safety.</li>
                        <li><b>Quality Components:</b> Suitable solar and electrical components selected according to project requirements.</li>
                        <li> <b>Efficient Execution:</b> A structured installation process designed to minimize disruption.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default SolarElectricalInstallation